import { CommonModule, registerLocaleData } from '@angular/common';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import ptBR from '@angular/common/locales/pt';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { ConfirmacaoService } from 'maestro-ng';
import { AplicacaoDadosComponent } from './aplicacao/aplicacao-dados/aplicacao-dados.component';
import { AppSharedModule } from './app-shared.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing';
import { AppService } from './app.service';
import { ArquivoModule } from './arquivo/arquivo.module';
import { AssuntoModule } from './assunto/assunto.module';
import { AutenticacaoModule } from './autenticacao/autenticacao.module';
import { AvisoComponent } from './aviso/aviso-component';
import { CepModule } from './cep/cep.module';
import { ClasseModule } from './classe/classe.module';
import { CompetenciaLocalModule } from './competencia-local/competencia-local.module';
import { CompetenciaModule } from './competencia/competencia.module';
import { ComponentsModule } from './components/components.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FonteDadosEstatisticasLocalModule } from './fonte-dados-estatisticas-local/fonte-dados-estatisticas-local.module';
import { FonteDadosModule } from './fonte-dados/fonte-dados.module';
import { initializer } from './initializer.service';
import { AutenticacaoHttpInterceptor } from './interceptor/autenticacao-http.interceptor';
import { JurisdicaoModule } from './jurisdicao/jurisdicao.module';
import { LocalidadeModule } from './localidade/localidade.module';
import { ManutencaoModule } from './manutencao/manutencao.module';
import { MensagemControleModule } from './mensagem-controle/mensagem-controle.module';
import { ModeloModule } from './modelo/modelo.module';
import { MonitoramentoModule } from './monitoramento/monitoramento.module';
import { OrgaoJulgadorColegiadoLocalModule } from './orgao-julgador-colegiado-local/orgao-julgador-colegiado-local.module';
import { OrgaoJulgadorLocalModule } from './orgao-julgador-local/orgao-julgador-local.module';
import { OrgaoJulgadorModule } from './orgao-julgador/orgao-julgador.module';
import { OrgaoJusticaModule } from './orgao-justica/orgao-justica.module';
import { PaisModule } from './pais/pais.module';
import { ParametroModule } from './parametro/parametro.module';
import { PerfilRecursoSegurancaModule } from './perfil-recurso-seguranca/perfil-recurso-seguranca.module';
import { PerfilModule } from './perfil/perfil.module';
import { PessoaAuditoriaAcessoModule } from './pessoa-auditoria-acesso/pessoa-auditoria-acesso.module';
import { PessoaDocumentoModule } from './pessoa-documento/pessoa-documento.module';
import { PessoaEnderecoModule } from './pessoa-endereco/pessoa-endereco.module';
import { PessoaGenitorModule } from './pessoa-genitor/pessoa-genitor.module';
import { PessoaOutroNomeModule } from './pessoa-outro-nome/pessoa-outro-nome.module';
import { PessoaRelacionamentoModule } from './pessoa-relacionamento/pessoa-relacionamento.module';
import { PessoaModule } from './pessoa/pessoa.module';
import { ProcessoAssuntoModule } from './processo-assunto/processo-assunto.module';
import { ProcessoAuditoriaAcessoModule } from './processo-auditoria-acesso/processo-auditoria-acesso.module';
import { ProcessoClasseModule } from './processo-classe/processo-classe.module';
import { ProcessoDistribuicaoModule } from './processo-distribuicao/processo-distribuicao.module';
import { ProcessoDocumentoModule } from './processo-documento/processo-documentos.module';
import { ProcessoMovimentoModule } from './processo-movimento/processo-movimento.module';
import { ProcessoParteModule } from './processo-parte/processo-parte.module';
import { ProcessoRelacionamentoModule } from './processo-relacionamento/processo-relacionamento.module';
import { ProcessoModule } from './processo/processo.module';
import { RecursoSegurancaModule } from './recurso-seguranca/recurso-seguranca.module';
import { SemPermissaoComponent } from './sem-permissao/sem-permissao.component';
import { SelectItemService } from './services/select-item.service';
import { TipoMovimentoModule } from './tipo-movimento/tipo-movimento.module';
import { TipoParteLocalModule } from './tipo-parte-local/tipo-parte-local.module';
import { TipoParteModule } from './tipo-parte/tipo-parte.module';
import { TipoProcessoDocumentoLocalModule } from './tipo-processo-documento-local/tipo-proc-doc-loc.module';
import { TipoProcessoDocumentoModule } from './tipo-processo-documento/tipo-proc-doc.module';
import { UnidadeFederativaModule } from './unidade-federativa/unidade-federativa.module';
import { UsuarioPermissaoModule } from './usuario-permissao/usuario-permissao.module';
import { UsuarioModule } from './usuario/usuario.module';
import { PessoaTelefoneModule } from './pessoa-telefone/pessoa-telefone.module';
import { PessoaEnderecoEletronicoModule } from './pessoa-endereco-eletronico/pessoa-endereco-eletronico.module';
import { ParticionamentoModule } from './particionamento/particionamento.module';
import { ProcessoIdentificacaoPeticaoInicialModule } from './processo-identificacao-peticao-inicial/processo-identificacao-peticao-inicial.module';
import { AccordionModule } from 'primeng/accordion';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {IndisponibilidadeModule} from './indisponibilidade/indisponibilidade.module';
import { FonteDadosComunicacaoModule } from './fonte-dados-comunicacao/fonte-dados-comunicacao.module';
import { OrgaoModule } from './orgao/orgao.module';
import {JurisdicaoLocalModule} from './jurisdicao-local/jurisdicao-local.module';
import { TimezoneService } from './services/timezone-service.service';
import { IndicadorArquivoModule } from './indicador-arquivo/indicador-arquivo.module';
import { TipoComplementoModule } from './tipo-complemento/tipo-complemento.module';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

registerLocaleData(ptBR, 'pt-BR');

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    SemPermissaoComponent,
    AplicacaoDadosComponent,
    AvisoComponent,
  ],
  imports: [
    AppSharedModule,
    BrowserModule,
    HttpClientModule,
    CommonModule,
    AccordionModule,
    BrowserAnimationsModule,

    // App
    AppRoutingModule,
    ComponentsModule,
    CompetenciaModule,
    UsuarioModule,
    FonteDadosModule,
    FonteDadosEstatisticasLocalModule,
    JurisdicaoModule,
    JurisdicaoLocalModule,
    ManutencaoModule,
    MensagemControleModule,
    MonitoramentoModule,
    ParametroModule,
    ParticionamentoModule,
    ProcessoModule,
    ProcessoAssuntoModule,
    ProcessoClasseModule,
    ProcessoDistribuicaoModule,
    ProcessoDocumentoModule,
    ProcessoMovimentoModule,
    ProcessoParteModule,
    ProcessoIdentificacaoPeticaoInicialModule,
    ProcessoRelacionamentoModule,
    TipoProcessoDocumentoModule,
    TipoParteModule,
    RecursoSegurancaModule,
    AutenticacaoModule,
    PerfilModule,
    UsuarioPermissaoModule,
    OrgaoJusticaModule,
    OrgaoJulgadorModule,
    OrgaoJulgadorLocalModule,
    OrgaoJulgadorColegiadoLocalModule,
    ModeloModule,
    ArquivoModule,
    TipoMovimentoModule,
    TipoComplementoModule,
    PerfilRecursoSegurancaModule,
    PessoaModule,
    PessoaDocumentoModule,
    PessoaEnderecoModule,
    PessoaOutroNomeModule,
    PessoaRelacionamentoModule,
    PessoaGenitorModule,
    PessoaEnderecoEletronicoModule,
    PessoaTelefoneModule,
    ClasseModule,
    AssuntoModule,
    CepModule,
    LocalidadeModule,
    UnidadeFederativaModule,
    PaisModule,
    KeycloakAngularModule,
    CompetenciaLocalModule,
    IndicadorArquivoModule,
    IndisponibilidadeModule,
    PessoaAuditoriaAcessoModule,
    ProcessoAuditoriaAcessoModule,
    TipoProcessoDocumentoLocalModule,
    TipoParteLocalModule,
    OrgaoJulgadorColegiadoLocalModule,
    FonteDadosComunicacaoModule,
    OrgaoModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    AppService,
    ConfirmacaoService,
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    SelectItemService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AutenticacaoHttpInterceptor,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializer,
      deps: [KeycloakService],
      multi: true
    },
    TimezoneService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
